/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ComputeVolumeDataInputType = {
  Huggingface: "huggingface",
  Git: "git",
} as const;
export type ComputeVolumeDataInputType = ClosedEnum<
  typeof ComputeVolumeDataInputType
>;

export type ComputeVolumeDataInput = {
  path: string;
  revision?: string | undefined;
  type: ComputeVolumeDataInputType;
  url: string;
};

/** @internal */
export const ComputeVolumeDataInputType$inboundSchema: z.ZodNativeEnum<
  typeof ComputeVolumeDataInputType
> = z.nativeEnum(ComputeVolumeDataInputType);
/** @internal */
export const ComputeVolumeDataInputType$outboundSchema: z.ZodNativeEnum<
  typeof ComputeVolumeDataInputType
> = ComputeVolumeDataInputType$inboundSchema;

/** @internal */
export const ComputeVolumeDataInput$inboundSchema: z.ZodType<
  ComputeVolumeDataInput,
  z.ZodTypeDef,
  unknown
> = z.object({
  path: z.string(),
  revision: z.string().optional(),
  type: ComputeVolumeDataInputType$inboundSchema,
  url: z.string(),
});
/** @internal */
export type ComputeVolumeDataInput$Outbound = {
  path: string;
  revision?: string | undefined;
  type: string;
  url: string;
};

/** @internal */
export const ComputeVolumeDataInput$outboundSchema: z.ZodType<
  ComputeVolumeDataInput$Outbound,
  z.ZodTypeDef,
  ComputeVolumeDataInput
> = z.object({
  path: z.string(),
  revision: z.string().optional(),
  type: ComputeVolumeDataInputType$outboundSchema,
  url: z.string(),
});

export function computeVolumeDataInputToJSON(
  computeVolumeDataInput: ComputeVolumeDataInput,
): string {
  return JSON.stringify(
    ComputeVolumeDataInput$outboundSchema.parse(computeVolumeDataInput),
  );
}
export function computeVolumeDataInputFromJSON(
  jsonString: string,
): SafeParseResult<ComputeVolumeDataInput, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeVolumeDataInput$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeVolumeDataInput' from JSON`,
  );
}
